'use es6';

import makeCurrencyField from './makeCurrencyField';
export default {
  hs_line_item_currency_code: makeCurrencyField()
};